module.exports = __webpack_public_path__ + "img/translate-02.86357868.svg";